import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { showInterstitial } from "../lib/ads";

// ⑥ 광고 게이트(§13) = 전면광고. 네이티브: AdMob 전면(미리 로드돼 거의 즉시 표시).
// 웹은 App의 goAd가 이 화면을 건너뛴다(Auto ads가 알아서 띄움) — 여긴 사실상 네이티브 전용.
export default function Ad({ onDone }: { onDone: () => void }) {
  const native = Capacitor.isNativePlatform();

  useEffect(() => {
    if (native) {
      let done = false;
      const guard = () => {
        if (done) return;
        done = true;
        onDone();
      };
      showInterstitial().finally(guard);
      return;
    }
    // 웹 방어용(정상 흐름에선 goAd가 건너뛰어 도달 안 함): 즉시 진행.
    const d = setTimeout(onDone, 300);
    return () => clearTimeout(d);
  }, [native, onDone]);

  // 전면광고가 거의 즉시 덮으므로, 로드되는 찰나엔 "광고 AdMob" 박스 대신 깔끔한 검은 배경 + 작은 로딩 점만.
  return (
    <div className="screen ad">
      <div className="ad-wait" aria-hidden="true" />
    </div>
  );
}
